import { loaderAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { getCashThunk } from "./getCashThunk";

export const removeCashThunk = (args) => async (dispatch, getState) => {
    const { user, cash } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.id || '');

        const response = await api({ data: formData, link: 'remove_cash' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(getCashThunk({
                payment_method: cash.payment_method.id,
                date_from: cash.date_from,
                date_to: cash.date_to
            }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};